import React from 'react';
import { Link } from 'react-router-dom';

const NextSteps = () => {
    return (
        <div className="md:tw-px-[10rem] md:tw-py-4 tw-p-4">
            {/* <h2><strong>About</strong></h2> */}

            <div className="tw-flex tw-flex-wrap">
                <div className="tw-w-full md:tw-w-11/12">
                    <h4 className='tw-text-[#37B048] tw-text-xl' >Next Steps and Resources</h4>

                    <p className='tw-mt-4'>To explore your options for making a more satisfying connection between your lists of values, you may:</p>
                    <b>
                        <ul className="tw-list-disc tw-list-inside">
                            <li>Talk with a trusted family member or friend to brainstorm changes you can make in your life;</li>
                            <li>Sit down with a colleague or supervisor to discuss your job tasks and goals in relation to your values;</li>
                            <li>Search online for information about career options; and/or</li>
                            <li>Find a career counselor/coach to gain in-depth career development assistance.</li>
                        </ul>
                    </b>
                    <p className="tw-mt-4 tw-text-blue-800 tw-font-bold">
                        If you are already working with a career counselor/coach, then it will be important to share your results and your ideas with her/him.
                        The career counselor/coach may provide guidance in the areas of career decision-making, job search, and life planning so that you
                        can move forward with confidence. If you are not already working with a career counselor/coach, you are strongly encouraged to
                        connect with someone who can help you utilize this assessment in a positive way.
                    </p>


                    <div className='tw-mt-8'></div>
                    <b className='tw-mt-4'>Finding a Career Counselor/Coach:</b>
                    <br />
                    <p className='tw-mt-4'>
                        Visit the National Career Development Association website at <a className='tw-text-blue-500 tw-underline tw-cursor-pointer' href="http://www.ncda.org" target="_blank">www.ncda.org</a> and click on
                        "Need Career Help?" on the home page. You can enter your zip code to locate a career counselor/coach in your area or click
                        on the link for a "more detailed search" to learn more about how to choose a counselor or the services of a career
                        counselor.
                    </p>
                    <p className='tw-mt-4'>
                        You can also locate a career counselor/coach by contacting the career center of a local college or university. Sometimes
                        the public library offers programs by career counselors/coaches.
                    </p>
                    {/* <p className='tw-mt-4'>
                        The Career Development Alliance (CDA) also has a network of career counselors available by phone and email. Please{' '}
                        <a href="contact-us.cfm">Contact Us</a> for more details.
                    </p> */}


                    <div className='tw-mt-8'></div>
                    <h4 className='tw-text-[#37B048] tw-text-xl tw-mt-4' >Need More Resources?</h4>

                    <p className='tw-mt-4'>
                        Values, while important, are just one part of you. More self-knowledge may be needed to gain a more satisfying life and
                        career. Other areas of assessment that may help an individual include interests, skills, and personality. Some of the most
                        widely used assessments include the:
                    </p>
                    <ul className="tw-list-disc tw-list-inside">
                        <li>Strong Interest Inventory ©</li>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://self-directed-search.com'} target='_blank'>Self-Directed Search</Link ></li>
                        <li>Campbell Interest and Skill Survey ©</li>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://www.skillscan.com/'} target='_blank'>SkillScan</Link ></li>
                        <li>Myers-Briggs Type Indicator ©</li>
                        <li>Keirsey Temperament Sorter-II ©</li>
                    </ul>
                    <ul className="tw-list-disc tw-list-inside tw-mt-3">
                        <p className='tw-font-bold'>Additional Sites to Explore</p>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://www.viacharacter.org/'} target='_blank'>VIA – Character Strengths</Link></li>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://career.missouri.edu/career-interest-game'} target='_blank'>Career Interests Game – University of Missouri</Link></li>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://www.16personalities.com/free-personality-test'} target='_blank'>16 Personalities</Link></li>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://www.truity.com/test/type-finder-personality-test-new'} target='_blank'>Truity</Link></li>
                        <li><Link className='tw-text-blue-500 tw-underline tw-cursor-pointer' to={'https://www.careeronestop.org/ExploreCareers/Assessments/skills.aspx'} target='_blank'>Skills and other assessments from CareerOneStop</Link></li>
                    </ul>

                    <p className='tw-mt-4'>
                        Several of these assessments may only be available to you while working with a career counselor/coach. The above assessments are
                        just a few examples and are provided for informational purposes only. No recommendation, endorsement, or warranty should be
                        interpreted or implied. Talk to your counselor/coach about all your options.
                    </p>

                    <p className='tw-mt-4'>
                        Additional resources  identified as free and helpful  are listed under Resources on the website for the National
                        Career Development Association at <a className='tw-text-blue-500 tw-underline tw-cursor-pointer' target='_blank' href="https://www.ncda.org/aws/NCDA/pt/sp/resources"><b>www.ncda.org</b></a>
                    </p>

                    <div className='tw-mt-8'></div>
                    <h4 className='tw-text-[#37B048] tw-text-xl'>Additional Resources from Career Development Alliance</h4>
                    <ul className="tw-list-disc tw-list-inside tw-mt-2">
                        <li>
                            <a
                                className="tw-text-blue-500 tw-underline"
                                href="/resources/Life_Career_Values.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Life Career Values
                            </a>
                        </li>
                        <li>
                            <a
                                className="tw-text-blue-500 tw-underline"
                                href="/resources/Values_Sort_Instructions.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Values Sort Instructions
                            </a>
                        </li>

                        <li>
                            <a
                                className="tw-text-blue-500 tw-underline"
                                href="/resources/Values_Worksheet.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Values Sort Worksheet
                            </a>
                        </li>

                        <li>
                            <a
                                className="tw-text-blue-500 tw-underline"
                                href="/resources/Career_AIM.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Career AIM
                            </a>
                        </li>

                        <li>
                            <a
                                className="tw-text-blue-500 tw-underline"
                                href="/resources/Pillars_of_a_Balanced_Life.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Pillars of a Balanced Life
                            </a>
                        </li>

                        <li>
                            <a
                                className="tw-text-blue-500 tw-underline"
                                href="/resources/Reverse_Stage_Goal_Setting.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Reverse Stage Goal Setting
                            </a>
                        </li>


                    </ul>
                </div>
            </div>
        </div>
    );
};

export default NextSteps;
